// Build identifier, stamped into both the client and server bundles at build
// time by build.mjs (esbuild `define` replaces `process.env.BUILD_ID` with a
// string literal). The client and server built from the same commit share it;
// when a client running an older bundle reconnects to a newer server, the
// mismatch is what triggers the "refresh to keep playing" gate. Defaults to
// 'dev' for un-bundled runs (typecheck, tests), where no gate should fire.
export const BUILD_ID: string = process.env.BUILD_ID ?? 'dev'
